import { Injectable } from "@angular/core";
import { Course } from "../models/course";
import { Lesson } from "../models/lesson";

@Injectable({
  providedIn: "root",
})
export class StaticDataService {

  constructor() {}

  public getActivityDefaultText(
    index: number,
    lesson: Lesson,
    course: Course
  ): string {

    // Hello song
    if (1 == index) {
      return this.isRhythmKids(lesson, course)
        ? "Ritual opening"
        : "Hello (Ritual)";
    }

    // Goodbye song
    if (lesson.numSongs == index) {
      return this.isRhythmKids(lesson, course)
        ? "Ritual closing"
        : "Goodbye (Ritual)";
    }

    if (index > 1 && index < lesson.numSongs) {

      // Eval has made my life Evil so removing it
      // return eval(`this.getActivity${index}Text(lesson, course)`);
      
      switch (index) {
        case 2:{
          return this.getActivity2Text(lesson, course)
        }
        case 3:{
          return  this.getActivity3Text(lesson, course)
        }
        case 4:{
          return this.getActivity4Text(lesson, course)
        }
        case 5:{
          return this.getActivity5Text(lesson, course)
        }
        case 6:{
          return this.getActivity6Text(lesson, course)
        }
        case 7:{
          return this.getActivity7Text(lesson, course)
        }
        case 8:{
          return this.getActivity8Text(lesson, course)
        }
        case 9:{
          return this.getActivity9Text(lesson, course)
        }
        case 10:{
          return this.getActivity10Text(lesson, course)
        }
        case 11:{
          return this.getActivity11Text(lesson, course)
        }
        case 12:{
          return this.getActivity12Text(lesson, course)
        }
        case 13:{
          return this.getActivity13Text(lesson, course)
        }
        case 14:{
          return this.getActivity14Text(lesson, course)
        }

        default:
          break;
      }
    }

    return "Activity Notes";
  }

  private isRhythmKids(lesson: Lesson, course: Course) {
    const rhythmKidsTypes = [
      Course.ClassType.RhythmKids,
      Course.ClassType.RhythmKidsLevel1,
      Course.ClassType.RhythmKidsLevel2,
    ];
    return rhythmKidsTypes.includes(course.classType);
  }

  private getActivity2Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.Babies) {
      return "Focus/purposeful touch";
    }
    if (this.isRhythmKids(lesson, course)) {
      return "Small mvt";
    }
    return "Focus";
  }

  private getActivity3Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.Babies) {
      return "Laps/tummy time";
    }
    if (lesson.classType == Course.ClassType.RhythmKidsLevel1) {
      return "Animal pattern/dramatic play";
    }
    if (lesson.classType == Course.ClassType.RhythmKidsLevel2) {
      return "Pattern instruction";
    }
    if (course.classType == Course.ClassType.InSchool) {
      if (lesson.numSongs == 7) {
        return "Small/large mvt or large mvt/circle skills";
      }
      return "Small/large mvt";
    }
    return "Lap/dyad";
  }

  private getActivity4Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.Babies) {
      return "Large mvt (dance with baby)";
    }
    if (course.classType == Course.ClassType.InSchool) {
      if (lesson.numSongs == 7) {
        return "Instrument/prop";
      }
      return "Instrument/prop or large mvt/circle skills";
    }
    return "Large mvt";
  }

  private getActivity5Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.InSchool) {
      if (lesson.numSongs == 7) {
        return "Large mvt/circle skills";
      }
      return "Large mvt/circle skills or instrument/prop";
    }
    return "Instrument/prop";
  }

  private getActivity6Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.Babies) {
      return "Focus/sound layering";
    }
    if (this.isRhythmKids(lesson, course)) {
      return "Music game";
    }
    if (course.classType == Course.ClassType.InSchool) {
      if (lesson.numSongs == 7) {
        return "Lullaby";
      }
      return "Calm and cool";
    }
    return "Focus";
  }

  private getActivity7Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.MixedAges) {
      if (lesson.numSongs == 12) {
        return "Small/large mvt";
      }
      return "Small mvt";
    }
    if (course.classType == Course.ClassType.Babies) {
      return "Large mvt (dance for baby)";
    }
    if (course.classType == Course.ClassType.Generations) {
      if (lesson.numSongs == 10) {
        return "Dance/free mvt";
      }
      return "Instrument/prop or small/large mvt";
    }

    if (lesson.classType == Course.ClassType.RhythmKidsLevel1) {
      return "Drum and sing";
    }
    if (lesson.classType == Course.ClassType.RhythmKidsLevel2) {
      return "Pattern play-along";
    }
    if (course.classType == Course.ClassType.InSchool) {
      if (lesson.numSongs == 7) {
        return "Goodbye (Ritual)";
      }
      return "Lullaby";
    }
    return "";
  }

  private getActivity8Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.MixedAges) {
      if (lesson.numSongs == 12) {
        return "Instrument/prop";
      }
      return "Large mvt";
    }
    if (course.classType == Course.ClassType.Babies) {
      if (lesson.numSongs == 10) {
        return "Drum-along or play-along";
      }
      return "Dance/free mvt";
    }
    if (course.classType == Course.ClassType.Generations) {
      if (lesson.numSongs == 10) {
        return "Play-along";
      }
      return "Dance/free mvt";
    }
    if (this.isRhythmKids(lesson, course)) {
      return "Quiet moment";
    }

    return "";
  }

  private getActivity9Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.MixedAges) {
      if (lesson.numSongs == 12) {
        return "Dance/free mvt";
      }
      return "Instrument/prop";
    }
    if (course.classType == Course.ClassType.Babies) {
      if (lesson.numSongs == 10) {
        return "Lullaby";
      }
      return "Drum-along or play-along";
    }
    if (course.classType == Course.ClassType.Generations) {
      if (lesson.numSongs == 10) {
        return "Lullaby";
      }
      return "Play-along";
    }
    return "";
  }

  private getActivity10Text(lesson: Lesson, course: Course) {
    if (course.classType == Course.ClassType.MixedAges) {
      if (lesson.numSongs == 12) {
        return "Play-along";
      }
      return "Dance/free mvt";
    }
    return "Lullaby";
  }

  private getActivity11Text(lesson: Lesson, course: Course) {
    if (lesson.numSongs == 12) {
      return "Lullaby";
    }
    return "Re-focus";
  }

  private getActivity12Text(lesson: Lesson, course: Course) {
    return "Play-along";
  }

  private getActivity13Text(lesson: Lesson, course: Course) {
    return "Lullaby";
  }

  private getActivity14Text(lesson, course) {
    return "";
  }
}
